import globalConfig from '../config/global-variables'
import languageModel from '../models/language.model'
import loginModel from '../models/login.model'

var indexedDB = window.indexedDB ||
    window.webkitIndexedDB ||
    window.mozIndexedDB;

var DBConn;

var languagesStorage = {

    openDatabase: function (dbObject, resolve, reject) {
        return new Promise(function (resolve, reject) {
            //1.Open database
            var request = window.indexedDB.open(dbObject.dbName, dbObject.dbVersion);

            request.onerror = function (event) {
                console.error("Error on connecting database");
                reject(e);
            };

            request.onsuccess = function (event) {
                //instance of IDBDatabase
                DBConn = request.result;
                resolve();
                languagesStorage.checkTableExit(globalConfig.LanguageDB, 1).then((res) => {
                    if (res == "NOT_FOUND") {
                        //call api and get language data from database
                        languagesStorage.getLanguages();
                    } else {
                        //fetch all data
                        languagesStorage.fetchTableData(globalConfig.LanguageDB);
                    }
                });
            };

            request.onupgradeneeded = function (event) {
                //2.Create an objectStore for this database
                if (!event.currentTarget.result.objectStoreNames.contains(dbObject.dbTable)) {
                    var objectTable = event.currentTarget.result.createObjectStore(dbObject.dbTable, { autoIncrement: true });  //{keyPath: "Id", autoIncrement: true}); //{keyPath: "id"}); 
                    // console.log("objectTable: ", JSON.stringify(objectTable));
                }
                resolve();
            }
        })
    },

    checkTableExit: function (dbObject, key) {
        return new Promise((resolve, reject) => {
            if (DBConn) {
                var transaction = DBConn.transaction([dbObject.dbTable]);
                var objectStore = transaction.objectStore(dbObject.dbTable);
                var request = objectStore.getAll(); //get(1);

                request.onsuccess = (r) => {
                    if (r.target.result === undefined || r.target.result.length == 0) {
                        resolve("NOT_FOUND");
                    } else {
                        resolve(r.target.result);
                    }
                }
                request.onerror = (e) => {
                    console.error("Error on getting info:" + e);
                    reject(e);
                }
            }
        });
    },

    clearData: function (result, dbObject) {
        var transaction = DBConn.transaction([dbObject.dbTable], 'readwrite'),
            objectStore = transaction.objectStore(dbObject.dbTable);
        // Make a request to clear all the data out of the object store
        var objectStoreRequest = objectStore.clear();

        objectStoreRequest.onsuccess = function (event) {
            // report the success of our request
            var transaction = DBConn.transaction([dbObject.dbTable], 'readwrite'),
                store = transaction.objectStore(dbObject.dbTable);

            try {
                store.add(result);
                let currentDate = new Date();
                store.add(currentDate);
                languagesStorage.fetchTableData(globalConfig.LanguageDB);
            } catch (e) {
                console.error(e.message)
            }
        };
    },

    addTableData: function (result, dbObject) {
        // Clear all the data form the object store
        languagesStorage.clearData(result, dbObject);
    },

    fetchTableData: function (dbObject) {
        var records = [];
        if (!DBConn.objectStoreNames.contains(dbObject.dbTable)) {
            // console.log("No table exists");
            return;
        }

        var trx = DBConn.transaction(dbObject.dbTable, "readonly");
        var objectStore = trx.objectStore(dbObject.dbTable);

        var request = objectStore.openCursor();
        request.onsuccess = function (event) {
            var cursor = event.target.result;
            if (cursor) {
                var menu = cursor.value;
                records.push(menu);
                cursor.continue();
            } else {
                // console.log("No more entries in Database!");
            }
        };

        request.onerror = function (event) {
            console.error(event.error);
        };

        trx.oncomplete = function (event) {
            try {
                if (records.length > 1) {
                    globalConfig.LanguageUpdatedDate = records[1];
                    languagesStorage.getLanguageLatestCreateDate();
                }
                let data = {};
                let ls = records.length > 0 ? records[0] : [];
                ls.forEach(l => {
                    data[l.code] = l;
                });
                globalConfig.LanguageData = null;
                globalConfig.LanguageData = data;
                m.redraw();
            } catch (ex) {
                console.error("Exception..." + ex);
            }
        };

        trx.onerror = function (event) {
            console.error(event);
        };

        trx.onabort = function (event) {
            console.error("transaction aborted");
        };
    },

    getLanguageLatestCreateDate: function () {
        languageModel.getLanguageDate(
            (result) => {
                // To convert last updated datetime from GMT+8 (DB server time) to client local time
                let langApiUpdated = new Date(result + ' +0800');
                let langUpdated = new Date(globalConfig.LanguageUpdatedDate); // Last updated datetime in client locale time

                if (langApiUpdated > langUpdated) { //globalConfig.testing
                    //globalConfig.testing = false;
                    setTimeout(() => {
                        //update indexed db data & call api and get language data from database
                        languagesStorage.getLanguages();
                    }, 5000)
                }
            }, (error) => {
                console.error("Error on getting language date:" + error);
            },
            'LabelText');
    },

    getLanguages: function () {
        // Get LabelText
        languageModel.getLanguageText(
            (result1) => {
                languagesStorage.addTableData(result1, globalConfig.LanguageDB);
            }, (error) => {
                console.error("Error on getting language data (All):" + error);
            },
            'All'
        )
    }
}

export default languagesStorage;
